let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gPaVZ")).then(() => parcelRequire('4O72a'));